import React,{Component} from "react"
import {NavBar, Toast} from 'antd-mobile';
import {packageInfo,packageOrder,packagePay,} from '../../../../service/memberService';
import './style.less';
import {connect} from "react-redux";
import PayModal from "../../../../components/PayModal";
@connect(
    state => ({userInfo: state.userInfo})
)
export default class PackageInfo extends Component{
    constructor(props) {
        super(props);
        this.state={
            payModal:false,
            data:"",
            payData:"",
            formPay:"",
        }
    }

    componentDidMount() {
        let params = {
            source:1,
            token:this.props.userInfo.token,
            data:{id:this.props.match.params.id}
        };
        packageInfo(params).then((res)=>{
            if(res.data.code == '0000'){
                this.setState({data:res.data.data})
            }else{
                Toast.info(res.data.msg,2)
            }
        })
    }
    goBuy(){
        let params = {
            source:1,
            token:this.props.userInfo.token,
            data:{
                id:this.props.match.params.id,
                purchaseCount:1,
            }
        };
        packageOrder(params).then((res)=>{
            if(res.data.code == '0000'){
                if(this.state.data.actuallyPrice > 0){
                    this.setState({payModal:true,payData:res.data.data});
                }else{
                    Toast.info("购买成功，请至优惠券账户查看详情",2,()=>this.props.history.goBack())
                }
            }else{
                Toast.info(res.data.msg,2)
            }
        })
    }
    payType(e){
        if(e == ""){
            Toast.info("请选择支付方式");
            return
        }
        if(e == "工商银行支付"){
            this.weiXinPay(this.state.payData,"icbcjft");
        }
        if(e== "微信支付"){
            this.weiXinPay(this.state.payData,"wx");
        }
        if(e == "民途钱包余额支付"){
            this.weiXinPay(this.state.payData,"wallet");
        }
    }
    weiXinPay = (orderNo,type) => {
        Toast.loading("",0);
        const params = {
            source: 1,
            token:this.props.userInfo.token,
            data:{
                source: 1,
                orderId: orderNo,
                payChannel:type,
            }
        };
        packagePay(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.hide();
                if(type == "wx"){
                    this.wxBridgeReady(res.data.data, orderNo);
                }else if(type == "wallet"){
                    Toast.info("购买成功",2,()=>this.props.history.goBack())
                }else{
                    // window.location.href = res.data.data.qrcode;
                    this.setState({formPay:res.data.data,});
                }
            } else {
                Toast.info(res.data.msg);
            }
        })
    };
    wxBridgeReady = (bridgeInfo, orderNo) => {
        const self = this;
        function onBridgeReady() {
            window.WeixinJSBridge.invoke(
                'getBrandWCPayRequest', {
                    "appId": bridgeInfo.appId,         //公众号名称，由商户传入
                    "timeStamp": bridgeInfo.timeStamp, //时间戳，自1970年以来的秒数
                    "nonceStr": bridgeInfo.nonceStr,   //随机串
                    "package": bridgeInfo.package,     //prepay_id
                    "signType": bridgeInfo.signType,   //微信签名方式
                    "paySign": bridgeInfo.sign         //微信签名
                },
                function (r) {
                    if (r.err_msg === "get_brand_wcpay_request:ok") {
                        Toast.info("购买成功",2,()=>self.props.history.goBack())
                    } else if (r.err_msg === "get_brand_wcpay_request:cancel") {
                        self.setState({payModal:false})
                    } else if (r.err_msg === "get_brand_wcpay_request:fail") {
                        Toast.info('支付失败，请稍后重试', 2,);
                    }
                }
            );
        }

        if (typeof WeixinJSBridge === "undefined") {
            if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
            } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
            }
        } else {
            onBridgeReady();
        }
    };
    payFrom(){
        if(this.state.formPay !== ""){
            return(
                <form
                    name="auto_submit_form"
                    method="post"
                    action={this.state.formPay.url}>
                    <input
                        type="hidden"
                        name="biz_content"
                        value={this.state.formPay.bizContent} />
                    <input type="submit" value="立刻提交" style={{display:"none"}} onClick={setTimeout(()=>document.forms[0].submit(),100)}/>
                </form>
            )
        }else{
            return null
        }
    }
    render() {
        const {data}=this.state;
        return (
            <div className="packageInfo">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() =>this.props.history.goBack()}/>}
                >套餐详情</NavBar>
                <div className="content">
                    <div className="unused">
                       <p>{data.packageName}</p>
                        <span>{data.packageDescription}</span>
                    </div>
                    <div className="info">
                        <div className="tit">套餐包含:</div>
                        <div className="taocan">
                            {
                                data.packageExtensionParamList && data.packageExtensionParamList.map((res,i)=>(
                                    <div className="textBox" key={i}>
                                        <p className="describe">{res.businessDescription} {res.discountDescription} <span>{'x'+res.couponCount+"张"}</span></p>
                                        <p>{res.limitDescription}</p>
                                    </div>
                                ))
                            }
                        </div>

                    </div>
                    <div className="info">
                        <div className="tit">有效期</div>
                        <div className="description">{data.validityDescription}</div>
                    </div>
                    <div className="info">
                        <div className="tit">使用须知</div>
                        <div className="description">{data.description}</div>
                    </div>
                </div>


                <div className="footer">
                    <span>￥{data.displayPrice}</span>
                    <button className="go" onClick={() => this.goBuy()}>立即购买</button>
                </div>

                <PayModal
                    modal={this.state.payModal}
                    onClose={()=>this.setState({payModal:false})}
                    payType={this.payType.bind(this)}
                    // businessType={"intercity"}
                />
                {this.payFrom()}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/DiscountPackage/PackageInfo/index.js